import { TemporaryTokenManager } from '../cobler';

export enum AuthToken {
  REFRESH_TOKEN = 'cobli-refresh-token',
  ACCESS_TOKEN = 'cobli-access-token',
}

export const setAuthCookies = (refreshToken: string, accessToken?: string) => {
  localStorage.setItem(AuthToken.REFRESH_TOKEN, refreshToken);

  if (accessToken) {
    localStorage.setItem(AuthToken.ACCESS_TOKEN, accessToken);
  }
};

export const deleteAuthCookies = () => {
  localStorage.removeItem(AuthToken.REFRESH_TOKEN);
  localStorage.removeItem(AuthToken.ACCESS_TOKEN);
  TemporaryTokenManager.deleteTemporaryToken();
};

export const getAuthHeaders = () => {
  const jwt = localStorage.getItem(AuthToken.ACCESS_TOKEN);
  const cobliApiSid = localStorage.getItem(AuthToken.REFRESH_TOKEN) || '';
  return {
    'cobli-api-sid': cobliApiSid,
    ...(jwt && { Authorization: `Bearer ${jwt}` }),
  };
};
